module.exports = __webpack_public_path__ + "img/selec-f2f.e1090912.svg";